<script setup lang="ts">
import WrongLogin from '@/components/login/errorAlert/WrongLogin.vue';
import ThirdPartSignupForm from '@/components/login/ThirdPartSignupForm.vue';
import ThirdPartSMSVerification from '@/components/login/ThirdPartSMSVerification.vue';
import ThirdPartVerifySuccess from '@/components/login/ThirdPartVerifySuccess.vue';
import type { ThirdPartyLogin } from '@/models/interface/auth';

const showForm = shallowRef<{ [key: string]: Component }>({
  ThirdPartSignupForm,
  ThirdPartSMSVerification,
  ThirdPartVerifySuccess
});
const showAlert = shallowRef<{ [key: string]: Component }>({
  WrongLogin
});
const dialogVisible = defineModel('dialogVisible', { default: false });
const dialogFormVisible = ref(false);
const showPopup = ref(false);
const formChoose = ref('');
const information = ref<ThirdPartyLogin>({
  name: '',
  phone: '',
  sex: -1,
  code: ''
});

const handleClose = (continued: boolean) => {
  dialogVisible.value = false;

  if (continued) {
    formChoose.value = 'ThirdPartSignupForm';
    dialogFormVisible.value = true;
  }
};
</script>

<template>
  <div>
    <div class="custom-dialog">
      <el-dialog v-model="dialogVisible" :width="453" :show-close="false" :align-center="true">
        <div>
          <div class="dialog-top">
            <SvgIcon name="closeCurrentColor" class="close" @click="handleClose(false)" />
            <img src="/images/free-class.png" alt="" />
          </div>

          <div class="dialog-content">
            <h3>專屬你的體驗課程，只差最後一步</h3>
            <p>30 秒完成驗證，讓我們幫你安排最適合的體驗</p>

            <button @click="handleClose(true)">
              <span>立即體驗</span>
              <SvgIcon name="arrowRight" style="width: 20px; height: 20px" />
            </button>
          </div>
        </div>
      </el-dialog>

      <el-dialog v-model="dialogFormVisible" :show-close="false" :align-center="true">
        <component
          v-model:formChoose="formChoose"
          v-model:showPopup="showPopup"
          v-model:showAlert="showAlert"
          v-model:information="information"
          v-model:dialogFormVisible="dialogFormVisible"
          :is="showForm[formChoose]"
        />
      </el-dialog>

      <PopupOverlay v-model:showPopup="showPopup" :zIndex="9999">
        <component v-model:showPopup="showPopup" v-model:formChoose="formChoose" :is="showAlert" />
      </PopupOverlay>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/** style */
.custom-dialog {
  :deep(.el-dialog) {
    padding: 0;
    border-radius: 8px;
  }
  :deep(.el-dialog__header) {
    padding-bottom: 0;
  }
}

.dialog-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;

  line-height: 140%;
  letter-spacing: 0px;
  color: #191919cc;

  h3 {
    font-weight: 600;
    font-size: 20px;
  }

  p {
    font-weight: 400;
    font-size: 18px;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    border-radius: 4px;
    outline: none;
    border: 0;
    background-color: #f74768;
    width: 100%;
    padding: 8px 0;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 125%;
      letter-spacing: 0px;
    }
  }
}

.dialog-top {
  position: relative;
  height: 240px;
  background-color: #d9d1c6;
  border-radius: 8px 8px 0 0;
  z-index: 1;

  img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .close {
    position: absolute;
    right: 8px;
    top: 8px;
    color: #19191999;
    cursor: pointer;
    z-index: 1;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
